import React from 'react';
import { Box, Container } from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import { align_center, align_column } from '../../Styles/VMStyles';

const privacySections = [
  {
    title: 'Information Collection',
    content:
      'Venue Management may collect personal information from users, including but not limited to names, email addresses, and contact details, to provide and improve our services.',
  },
  {
    title: 'Use of Information',
    content:
      'We may use the information collected for various purposes, including to facilitate user access to the application, personalize user experience, communicate with users, and improve our products and services.',
  },
  {
    title: 'Data Security',
    content:
      'Venue Management employs industry-standard security measures to protect user data against unauthorized access, alteration, disclosure, or destruction.',
  },
  {
    title: 'Third-Party Disclosure',
    content:
      'We do not sell, trade, or otherwise transfer user information to third parties without user consent, except as required by law or to facilitate service providers in delivering our services.',
  },
  {
    title: 'Access and Control',
    content:
      'Users have the right to access, modify, or delete their personal information stored by Venue Management Solutions. Users may contact us to exercise their rights or address any privacy concerns.',
  },
  {
    title: 'Policy Changes',
    content:
      'Venue Management reserves the right to update or modify this Privacy Policy at any time. Users will be notified of any changes, and continued use of the application constitutes acceptance of the revised policy.',
  }
];

function VMPrivacyPolicy() {
  return (
    <Container maxWidth="md">
      <MUITypography
        align="center"
        gutterBottom
        sx={{ margin: '20px', fontWeight: 700, ...align_center }}
      >
        Privacy Policy
      </MUITypography>

      {privacySections.map((section, index) => (
        <Box key={index} sx={{ mt: 3, ...align_column }}>
          <MUITypography sx={{ fontWeight: 600, mb: 1 }}>
            {index + 1 + '. ' + section.title}
          </MUITypography>
          <MUITypography color="text.secondary" sx={{ paddingLeft: '20px' }}>
            {section.content}
          </MUITypography>
        </Box>
      ))}
    </Container>
  );
}

export default VMPrivacyPolicy;
